"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildRoomWebsocketChannel = exports.RoomWebsocketChannel = void 0;
var room_status_1 = require("./room-status");
var room_websocket_message_sender_1 = require("./room-websocket-message-sender");
var room_util_1 = require("./room-util");
var collab_room_reporter_1 = __importDefault(require("../report/collab-room-reporter"));
var config_1 = require("../socket.io/config");
var RoomWebsocketChannel = /** @class */ (function () {
    function RoomWebsocketChannel(padInfo, roomDependency) {
        this.padInfo = padInfo;
        this.roomDependency = roomDependency;
        this.websocketMessageSender = new room_websocket_message_sender_1.RoomWebsocketMessageSender(this.padInfo, this.roomDependency, this);
        this.roomStatus = new room_status_1.RoomStatus(this.websocketMessageSender, __assign({}, this.padInfo), this.roomDependency);
    }
    RoomWebsocketChannel.prototype.connect = function () {
        this.websocketMessageSender.openWebsocketConnection();
    };
    RoomWebsocketChannel.prototype.disconnect = function (reason) {
        var _a, _b;
        var messageInfo = {
            module: this.padInfo.module,
            attrName: String((_a = reason.errCode) !== null && _a !== void 0 ? _a : 0),
            status: 1 /* FAILED */,
            errorMessage: room_util_1.RoomUtil.getWebsocketChannelErrorMessage((_b = reason.errCode) !== null && _b !== void 0 ? _b : 0),
        };
        this.websocketMessageSender.shutDown(reason);
        collab_room_reporter_1.default.shutDownReport(messageInfo);
    };
    RoomWebsocketChannel.prototype.dispose = function () {
        this.websocketMessageSender.dispose();
        this.roomStatus.dispose();
    };
    RoomWebsocketChannel.prototype.sendMessage = function (message) {
        this.websocketMessageSender.sendMessage(message);
    };
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    RoomWebsocketChannel.prototype.batchCommitMessages = function (messages) {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                result = {
                    success: false,
                    retCode: 52002 /* WEBSOCKET_UNSUPPORT_BATCH_COMMIT */,
                    reason: 'websocket not support batch commit.',
                };
                return [2 /*return*/, result];
            });
        });
    };
    RoomWebsocketChannel.prototype.cancelSendMessageByTaskId = function (seq) {
        this.websocketMessageSender.cancelSendMessageByTaskId(seq);
    };
    /* IRoomWebsocketChannelDependency begin */
    RoomWebsocketChannel.prototype.openRoom = function () {
        this.roomStatus.openRoom();
    };
    RoomWebsocketChannel.prototype.onRoomClosed = function (reason) {
        this.roomStatus.onRoomClosed(reason);
    };
    RoomWebsocketChannel.prototype.roomStateReconnecting = function () {
        this.roomStatus.roomStateReconnecting();
    };
    RoomWebsocketChannel.prototype.getRoomState = function () {
        return this.roomStatus.getRoomState();
    };
    RoomWebsocketChannel.prototype.loginRoom = function () {
        this.roomStatus.loginRoom();
    };
    RoomWebsocketChannel.prototype.onLoginResponse = function (head, body) {
        this.roomStatus.onLoginResponse(head, body);
    };
    RoomWebsocketChannel.prototype.resetLogin = function () {
        this.roomStatus.resetLogin();
    };
    RoomWebsocketChannel.prototype.onHeartBeatResponse = function (head, body) {
        this.roomStatus.onHeartBeatResponse(head, body);
    };
    RoomWebsocketChannel.prototype.resetHeartBeat = function () {
        this.roomStatus.resetHeartBeat();
    };
    return RoomWebsocketChannel;
}());
exports.RoomWebsocketChannel = RoomWebsocketChannel;
// eslint-disable-next-line complexity
function BuildRoomWebsocketChannel(options, dependency, middleWareCenter) {
    var _a, _b, _c, _d, _e, _f;
    var channelOptions = {
        module: options.module,
        padId: options.serverVars.padId,
        globalPadId: options.serverVars.globalPadId,
        codeVer: (_a = options.serverVars.pver) !== null && _a !== void 0 ? _a : 0,
        gray: (_b = options.serverVars.gray) !== null && _b !== void 0 ? _b : 0,
        dver: options.serverVars.dver,
        pver: options.serverVars.pver,
        apId: options.serverVars.apid,
        wmode: (_c = options.serverVars.wmode) !== null && _c !== void 0 ? _c : config_1.DEFAULT_WMODE,
        padType: options.serverVars.padType,
        websocketReopenCount: (_d = options.serverVars.websocketReopenCount) !== null && _d !== void 0 ? _d : config_1.WEBSOCKET_CONFIG.pollingReopenCount,
        pollingAttemptNumber: (_e = options.serverVars.pollingAttemptNumber) !== null && _e !== void 0 ? _e : config_1.WEBSOCKET_CONFIG.pollingAttemptCount,
        upid: options.serverVars.client.upid,
        sid: options.serverVars.client.sid,
        tid: options.serverVars.client.tid,
        sig: options.serverVars.client.sig,
        uid: options.uid,
        uuId: options.userid,
        userId: options.userid,
        nowUserIndex: (_f = options.nowUserIndex) !== null && _f !== void 0 ? _f : window.nowUserIndex,
        middleWareCenter: middleWareCenter,
        config: options.config,
    };
    return new RoomWebsocketChannel(channelOptions, dependency);
}
exports.BuildRoomWebsocketChannel = BuildRoomWebsocketChannel;
